import {Box, Divider, Grid, Typography} from '@mui/material';
import {SimpleFilePreview} from 'components/form/dropzone';
import AppControlledMediaFileUpload from 'components/form/dropzone/AppControlledMediaFileUpload';
import {useCreateMediaFiles, useDeleteMediaFilesByIds, useGetAllMediaFiles} from 'hooks';
import {MediaFileCreateRequestModel, MediaFileModel, MediaFileObjectTypeEnum} from 'models';
import {ItemDataResponse} from 'models/board';
import React, {useCallback, useEffect} from 'react';
import {useForm} from 'react-hook-form';
interface ItemDataAttachmentsTabProps {
    itemData: ItemDataResponse;
}
export const ItemDataAttachmentsTab: React.FC<ItemDataAttachmentsTabProps> = ({itemData}) => {
    const {control, watch, reset} = useForm<MediaFileCreateRequestModel>({
        defaultValues: {
            objectId: itemData.id,
            objectType: MediaFileObjectTypeEnum.ITEM_DATA.toString(),
            files: [],
        },
    });
    const {getAllMediaFiles, getAllMediaFilesResponse, getAllMediaFilesLoading} = useGetAllMediaFiles();
    const {createMedieFile, createMedieFileResponse, createMedieFileLoading} = useCreateMediaFiles();
    const {deleteMediaFilesByIds, deleteMediaFilesByIdsResponse, deleteMediaFilesByIdsLoading} =
        useDeleteMediaFilesByIds();
    const watchedFiles = watch('files');

    const memoizedGetAllMediaFile = useCallback(() => {
        if (itemData.id) {
            reset({
                objectId: itemData.id,
                objectType: MediaFileObjectTypeEnum.ITEM_DATA.toString(),
                files: [],
            });
            getAllMediaFiles({
                variables: {
                    where: {
                        objectId: {eq: itemData.id},
                        objectType: {eq: MediaFileObjectTypeEnum.ITEM_DATA.toString()},
                    },
                },
            });
        }
    }, [itemData.id, getAllMediaFiles]);

    useEffect(() => {
        if (deleteMediaFilesByIdsResponse) {
            memoizedGetAllMediaFile();
        }
    }, [deleteMediaFilesByIdsResponse]);

    useEffect(() => {
        if (createMedieFileResponse) {
            memoizedGetAllMediaFile();
        }
    }, [createMedieFileResponse]);

    useEffect(() => {
        memoizedGetAllMediaFile();
    }, [memoizedGetAllMediaFile]);

    const deleteFileHandler = (file: MediaFileModel) => {
        deleteMediaFilesByIds({
            variables: {
                ids: [file.id],
            },
        });
    };

    useEffect(() => {
        if (watchedFiles && watchedFiles.length > 0) {
            createMedieFile({
                variables: {
                    objectId: itemData.id,
                    objectType: MediaFileObjectTypeEnum.ITEM_DATA.toString(),
                    files: watchedFiles,
                },
            });
        }
    }, [watchedFiles]);

    return (
        <Grid container spacing={1} id="Attachments">
            <Grid item xs={12}>
                <Box display="flex" alignItems="end">
                    <Typography variant="h5">Attachments</Typography>
                </Box>
                <Divider
                    sx={{
                        my: 1,
                        borderStyle: 'dotted',
                        borderColor: 'tertiary.main',
                        borderWidth: '1px',
                    }}
                />
            </Grid>
            <Grid item xs={12}>
                <AppControlledMediaFileUpload
                    name="files"
                    control={control}
                    loading={createMedieFileLoading}
                    label=""
                    allowAllMedia={true}
                    multiple={true}
                    maxFiles={2}
                    maxSize={50 * 1024 * 1024} // 50MB
                />
            </Grid>
            <Grid item xs={12}>
                <SimpleFilePreview
                    loading={getAllMediaFilesLoading || createMedieFileLoading || deleteMediaFilesByIdsLoading}
                    files={getAllMediaFilesResponse ?? []}
                    onRemove={deleteFileHandler}
                />
            </Grid>
        </Grid>
    );
};

export default ItemDataAttachmentsTab;
